var map = {
	"./arctic_zone.geo.json": [
		6465,
		465
	],
	"./balticsea_zone.geo.json": [
		5751,
		751
	],
	"./blacksea_zone.geo.json": [
		3871,
		871
	],
	"./global_zone.geo.json": [
		2308,
		308
	],
	"./ibi_zone.geo.json": [
		6249,
		249
	],
	"./medsea_zone.geo.json": [
		7026,
		26
	],
	"./nws_zone.geo.json": [
		5743,
		743
	],
	"resources/zones/arctic_zone.geo.json": [
		6465,
		465
	],
	"resources/zones/balticsea_zone.geo.json": [
		5751,
		751
	],
	"resources/zones/blacksea_zone.geo.json": [
		3871,
		871
	],
	"resources/zones/global_zone.geo.json": [
		2308,
		308
	],
	"resources/zones/ibi_zone.geo.json": [
		6249,
		249
	],
	"resources/zones/medsea_zone.geo.json": [
		7026,
		26
	],
	"resources/zones/nws_zone.geo.json": [
		5743,
		743
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 395;
module.exports = webpackAsyncContext;